import React from 'react'
import PullToRefresh from 'react-simple-pull-to-refresh';
import { VariaveisAmbiente } from '../../../config';
import { EnumDeviceType } from '../../../model/enums/enum-device-type';
import { useLocation } from 'react-router-dom';

export const PullToRefreshContainer = ({ children }: any) => {
    const location = useLocation()
    const isPullable = ['/monitoramento', '/pedidos-para-entrega', '/entregas-pendentes', '/cancelados-concluidos'].includes(location.pathname)
    if (VariaveisAmbiente.paymentDevice !== EnumDeviceType.CORDOVA) {
        return <>
            {children}
        </>
    }

    return <PullToRefresh isPullable={isPullable} onRefresh={async () => {
        window.location.reload()
    }} pullingContent={<></>}>
        {children}
    </PullToRefresh>
}